import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import ProfileDetails from "./Components/ProfileSettings/PersonalDetails";
import { useParams, useNavigate } from "react-router-dom";
import ExperienceEducation from "./Components/ProfileSettings/ExperienceEducation";
import AwardsDownloads from "./Components/ProfileSettings/AwardsDownloads";
import Registrations from "./Components/ProfileSettings/Registrations";
import Gallery from "./Components/ProfileSettings/Gallery";
import Defaultlocation from "./Components/ProfileSettings/Defaultlocation";
import SocialProfiles from "./Components/ProfileSettings/Socialprofiles";
import { oneKlicks } from "../../SDK/oneclick";
import { OneKlicksFileSDK } from "../../SDK/OneKlicksFileSDK";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { getuserdata } from "../../services/apiService";
import Preloader from "../../Uitiles/Preloader";
import DashBordmenu from "../../Uitiles/DashBordmenu";

const ProfileSettings = () => {
    const [userdata, setUserdata] = useState({});
    const [userid, setUserId] = useState("");
    const { sublink } = useParams();
    const navigate = useNavigate();
    const [tabsest, setTabseset] = useState("Personal Details");
    const [isLoading, setIsLoading] = useState(true);
    const [educations, setEducations] = useState([]);
    const [experiences, setExperiences] = useState([]);
    const [awards, setAwards] = useState([]);
    const [downloads, setDownloads] = useState([]);
    const [showMenu, setShowMenu] = useState(false);
    const [localRegistrations, setLocalRegistrations] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);

    const [galleryImages, setGalleryImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [newVideoUrl, setNewVideoUrl] = useState("");
    const [galleryid, setGalleryid] = useState([]);


    const [selectedCountry, setSelectedCountry] = useState('india');
    const [searchAddress, setSearchAddress] = useState('');
    const [mapCenter, setMapCenter] = useState({ lat: 20.5937, lng: 78.9629 }); // Default to India
    const [fullAddress, setFullAddress] = useState('');
    // Tab to URL mapping
    const tabToUrlMapping = {
        "Personal Details": "personal-details",
        "Experience & Education": "experience-education",
        "Awards & Downloads": "awards-downloads",
        "Registrations": "registrations",
        "Gallery": "gallery",
        "Default location": "default-location",
        "Social profiles": "social-profiles"
    };

    useEffect(() => {
        // Handle tab state based on sublink
        if (sublink) {
            const tabMapping = {
                "experience-education": "Experience & Education",
                "awards-downloads": "Awards & Downloads",
                "registrations": "Registrations",
                "gallery": "Gallery",
                "default-location": "Default location",
                "social-profiles": "Social profiles",
                "personal-details": "Personal Details"
            };
            setTabseset(tabMapping[sublink] || "Personal Details");
        }
    }, [sublink]);

    const handleTabClick = (tabName) => {
        setTabseset(tabName);
        const urlPath = tabToUrlMapping[tabName];
        if (urlPath) {
            navigate(`/doctor/profile-settings/${urlPath}`);
        }
    };

    const [PersonalDetailsformdata, setPersonalDetailsFormdata] = useState({
        name: "",
        gendar: "",
        subheading: "",
        first_name: "",
        last_name: "",
        display_name: "",
        starting_price: "",
        mobile_number: "",
        description: "",
        languages: [],
        profile_photo: null,
        profile_banner: null,
        profile_banner_url: null,
        memberships: [],
        main_specialization: "",
    });


    const [socialProfiles, setSocialProfiles] = useState({
        facebook: "",
        twitter: "",
        linkedin: "",
        skype: "",
        pinterest: "",
        tumblr: "",
        instagram: "",
        flickr: "",
        medium: "",
        tripadvisor: "",
        wikipedia: "",
        vimeo: "",
        youtube: "",
        whatsapp: "",
        vkontakte: "",
        odnoklassniki: "",
        googleplus: "",
        telegram: "",
        twitch: "",
        discord: "",
        github: "",
        reddit: "",
        stackoverflow: ""
    });
    const [socialloading, setSocialLoading] = useState(true);
    const [localDoctorId, setLocalDoctorId] = useState("");

    useEffect(() => {
        const localDoctorId = localStorage.getItem("doctorId");
        console.log("localDoctorId", localDoctorId);
        setLocalDoctorId(localDoctorId);
        getalluserdata();
        getallexperienceeducation();
        getallregistrations();
        getallawardsdownloads();
        getallgallery();
        getalldefaultlocation();
        getallsocialprofiles();
        const userdataString = localStorage.getItem("userdata");
        if (userdataString) {
            try {
                const parsedUserdata = JSON.parse(userdataString);
                console.log("userData new", parsedUserdata);
                console.log("userData user id", parsedUserdata.id);
                setUserdata(parsedUserdata);
                setUserId(parsedUserdata.id);
            } catch (error) {
                console.error("Error parsing userdata from localStorage:", error);
            }
        }
    }, []);

    const getallsocialprofiles = async() => {
        setSocialLoading(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_social_profiles";
            const conditions = {
                user_id: await getuserdata("id"),
            };  
            const orderBy = "";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getcruserdata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("GET ALL SOCIAL PROFILES", getcruserdata.data[0]);
            console.log("GET ALL SOCIAL PROFILES localDoctorId", localStorage.getItem("doctorId"));
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setSocialProfiles(getcruserdata.data[0].social_profiles);
            }
        } catch (error) {
            console.error("Error fetching social profiles:", error);
        } finally {
            setSocialLoading(false);
        }
    };

    const getalldefaultlocation = async() => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_default_location";
            const conditions = {
                user_id: await getuserdata("id"),
            };
            const orderBy = "";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getcruserdata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("GET ALL DEFAULT LOCATION", getcruserdata.data[0]);
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setSelectedCountry(getcruserdata.data[0].country);
                setSearchAddress(getcruserdata.data[0].address);
                setMapCenter({ lat: getcruserdata.data[0].lat, lng: getcruserdata.data[0].lng }); 
                setFullAddress(getcruserdata.data[0].full_address);
            }
        } catch (error) {
            console.error("Error fetching default location:", error);
        } finally {
            setIsLoading(false);
        }
    };
    

    const getallgallery = async() => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_gallery";
            const conditions = {
                user_id: await getuserdata("id"),
            };
            const orderBy = "";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getcruserdata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("GET ALL GALLERY aa data ", getcruserdata.data[0]);  
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setGalleryImages(getcruserdata.data[0].images);
                setVideos(getcruserdata.data[0].videos);
                setGalleryid(getcruserdata.data[0].id);
            }
        } catch (error) {
            console.error("Error fetching gallery:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getallawardsdownloads = async() => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_awards_downloads";
            const conditions = {
                user_id: await getuserdata("id"),
            };
            const orderBy = "";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getcruserdata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("GET ALL AWARDS AND DOWNLOADS", getcruserdata.data[0]); 
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setAwards(getcruserdata.data[0].awards);
                setDownloads(getcruserdata.data[0].downloads);
            }
        } catch (error) {
            console.error("Error fetching awards and downloads:", error);
        }
    };
    const getallregistrations = async() => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_registrations";
            const conditions = {
                user_id: await getuserdata("id"),
            };
            const orderBy = "";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getcruserdata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("GET ALL REGISTRATIONS", getcruserdata.data[0]);    
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setLocalRegistrations(getcruserdata.data[0].registrations);
            }
        } catch (error) {
            console.error("Error fetching registrations:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getallexperienceeducation = async() => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_experience_education";
            const conditions = {
                user_id: await getuserdata("id"),
            };
            const orderBy = "";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getcruserdata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("getcruserdata", getcruserdata.data[0]);
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setEducations(getcruserdata.data[0].educations);
                setExperiences(getcruserdata.data[0].experiences);
            }
        } catch (error) {
            console.error("Error fetching experience and education data:", error);
        }
    };

    const getalluserdata = async() => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "users";
            const conditions = {
                id: await getuserdata("id")
            };

            console.log("conditions", conditions);
            const orderBy = "";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getcruserdata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("getcruserdata profiledata", getcruserdata);
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                const userData = getcruserdata.data[0];
                setUserdata(userData);
                setUserId(userData.id);

                let languages = userData.languages;
                let memberships = userData.memberships;
                
                if (typeof languages === 'string') {
                    try {
                        languages = JSON.parse(languages);
                    } catch (e) {
                        languages = [];
                    }
                }
                
                if (typeof memberships === 'string') {
                    try {
                        memberships = JSON.parse(memberships);
                    } catch (e) {
                        memberships = [];
                    }
                }
                
                setPersonalDetailsFormdata({
                    name: userData.name || "",
                    email: userData.email || "",
                    gendar: userData.gendar || "",
                    subheading: userData.subheading || "",
                    first_name: userData.first_name || "",
                    last_name: userData.last_name || "",
                    display_name: userData.display_name || "",
                    starting_price: userData.starting_price || "",
                    mobile_number: userData.phone || "",
                    description: userData.description || "",
                    languages: languages || [],
                    profile_photo: userData.profile_photo || null,
                    profile_photo_url: userData.profile_photo_url || null,
                    profile_banner: userData.profile_banner || null,
                    profile_banner_url: userData.profile_banner_url || null,
                    memberships: memberships || [],
                    main_specialization: userData.main_specialization || null,
                });
            }
        } catch (error) {
            console.log("getcruserdata profiledata error", error);
            toast.error('Failed to fetch user data');
        } finally {
            setIsLoading(false);
        }
    };

    const handlesubmit = async (e) => {
        e.preventDefault();
        
        // Form validation
        if (!PersonalDetailsformdata.first_name || !PersonalDetailsformdata.last_name) {
            toast.error("First name and last name are required");
            return;
        }

        if (!PersonalDetailsformdata.mobile_number) {
            toast.error("Mobile number is required");
            return;
        }

        if (!PersonalDetailsformdata.description) {
            toast.error("Description is required");
            return;
        }

        if (!PersonalDetailsformdata.display_name) {
            toast.error("Display name is required");
            return;
        }

        if (!PersonalDetailsformdata.starting_price) {
            toast.error("Starting price is required");
            return;
        }

        if (!PersonalDetailsformdata.gendar) {
            toast.error("Gender is required");
            return;
        }

        if (!PersonalDetailsformdata.main_specialization) {
            toast.error("Main specialization is required");
            return;
        }

        setIsLoading(true);
        console.log("PersonalDetailsformdata", PersonalDetailsformdata);
        const root = "doctors/profile";
        const status = "public";
        const file = PersonalDetailsformdata.profile_photo;
        let profilePhotoId = PersonalDetailsformdata.profile_photo;

        try {
            console.log("Starting profile update process. Current state:", PersonalDetailsformdata);
            
            // Only upload new file if it's a File object (new upload)
            if (file instanceof File) {
                console.log("New profile photo file detected. Starting upload...");
                if (!file.type.startsWith('image/')) {
                    toast.error("Please upload an image file");
                    setIsLoading(false);
                    return;
                }

                if (file.size > 5 * 1024 * 1024) { // 5MB limit
                    toast.error("File size should be less than 5MB");
                    setIsLoading(false);
                    return;
                }
                
                const uploadedFile = await OneKlicksFileSDK.uploadFile(root, status, file);
                console.log("File upload response:", uploadedFile);
                
                if (uploadedFile.success === true) {
                    profilePhotoId = uploadedFile.fileId;
                    console.log("File uploaded successfully. ID:", profilePhotoId);
                } else {
                    throw new Error(uploadedFile.error || "Failed to upload file");
                }
            } else {
                console.log("No new profile photo file to upload (current value is ID or empty).");
            }

            const user_id = await getuserdata("id");
            console.log("Current user ID from local storage:", user_id);
            
            if (!user_id) {
                throw new Error("User ID not found. Please log in again.");
            }
        
            console.log("Reading existing user data from DB...");
            const userData = await oneKlicks.read("", "users", { id: user_id }, "", "", "", "");
            console.log("User data read response:", userData);
            
            if (!userData.success || !userData.data.length) {
                throw new Error("Failed to fetch user data from database");
            }

            const tableName = "users";
            const tableSchema = "";
            const data = {
                gendar: PersonalDetailsformdata.gendar,
                subheading: PersonalDetailsformdata.subheading,
                first_name: PersonalDetailsformdata.first_name,
                last_name: PersonalDetailsformdata.last_name,
                display_name: PersonalDetailsformdata.display_name,
                starting_price: PersonalDetailsformdata.starting_price,
                phone: PersonalDetailsformdata.mobile_number,
                description: PersonalDetailsformdata.description,
                languages: JSON.stringify(PersonalDetailsformdata.languages),
                profile_photo: profilePhotoId, // Fixed: use the uploaded ID
                profile_photo_url: PersonalDetailsformdata.profile_photo_url,
                profile_banner: PersonalDetailsformdata.profile_banner,
                profile_banner_url: PersonalDetailsformdata.profile_banner_url,
                memberships: JSON.stringify(PersonalDetailsformdata.memberships),
                main_specialization: PersonalDetailsformdata.main_specialization,
            };

            const condition = {
                id: user_id,
            };
    
            console.log("Performing update on users table...", { data, condition });
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            console.log("Update database response:", updateData);

            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to update profile record in database");
            }
            
            toast.success("Profile updated successfully", {autoClose: 2000});
            await getalluserdata(); // Refresh user data after successful update
            
        } catch (err) {
            console.error("Error:", err);
            toast.error(err.message || "An unexpected error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    const handleExperienceEducationSubmit = async (e) => {
        e.preventDefault();

        const invalidEdu = educations.some(edu => !edu.institute_name || !edu.degree_title || !edu.start_date);
        if (invalidEdu) {
            toast.error("Institute name, degree title, and start date are required for all educations");
            return;
        }

        const invalidExp = experiences.some(exp => !exp.company_name || !exp.job_title || !exp.start_date);
        if (invalidExp) {
            toast.error("Company name, job title, and start date are required for all experiences");
            return;
        }

        setIsLoading(true);
        try {
            
            const tableName = "doctor_experience_education";
            const tableSchema = "";
            const data = {
                user_id: await getuserdata("id"),
                educations: JSON.stringify(educations),
                experiences: JSON.stringify(experiences)
            };
            const condition = {
                user_id: await getuserdata("id"),
            };
    
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to update experience and education");
            }
            
            toast.success("Experience and Education updated successfully", {autoClose: 2000});
            await getalluserdata(); // Refresh user data after successful update
            
        } catch (err) {
            console.error("Error:", err);
            toast.error(err.message || "An unexpected error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    const handleAwardsDownloadsSubmit = async (e) => {
        e.preventDefault();
        
        const invalidAward = awards.some(award => !award.title || !award.date);
        if (invalidAward) {
            toast.error("Title and date are required for all awards");
            return;
        }

        const invalidDownload = downloads.some(dl => !dl.title);
        if (invalidDownload) {
            toast.error("Title is required for all downloads");
            return;
        }

        setIsLoading(true);
        console.log("awards", awards);
        console.log("downloads", downloads);

        try {
            const tableName = "doctor_awards_downloads";
            const tableSchema = "";
            const data = {
                user_id: await getuserdata("id"),
                awards: JSON.stringify(awards),
                downloads: JSON.stringify(downloads)
            };
            const condition = {
                user_id: await getuserdata("id"),
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to update awards and downloads");
            }
            toast.success("Awards and Downloads updated successfully", {autoClose: 2000});
            await getalluserdata(); // Refresh user data after successful update
        } catch (err) {
            console.error("Error:", err);
            toast.error(err.message || "An unexpected error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    const saveRegistrations = async (updatedRegistrations) => {
        setIsSaving(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_registrations";
            const data = {
                user_id: await getuserdata("id"),
                registrations: JSON.stringify(updatedRegistrations)
            };
            const condition = {
                user_id: await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to save registrations");
            }
            setHasChanges(false);
            return true;
        } catch (error) {
            console.error("Error saving registrations:", error);
            toast.error(error.message || "Failed to save registrations");
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    const handleRegistrationsSubmit = async (e) => {
        e.preventDefault();
        
        const invalidReg = localRegistrations.some(reg => !reg.registration_number);
        if (invalidReg) {
            toast.error("Registration number is required for all entries");
            return;
        }

        setIsLoading(true);
        if (!hasChanges) return;

        const success = await saveRegistrations(localRegistrations);
        if (success) {
            toast.success("Registrations updated successfully");
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (localRegistrations) {
            try {
                const parsedRegistrations = typeof localRegistrations === 'string' 
                    ? JSON.parse(localRegistrations) 
                    : localRegistrations;
                setLocalRegistrations(Array.isArray(parsedRegistrations) ? parsedRegistrations : []);
            } catch (e) {
                console.error("Error parsing registrations:", e);
                setLocalRegistrations([]);
            }
        }
    }, [localRegistrations]);

    const handleGallerySubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const success = await saveGallery(galleryImages, videos);
        if (success) {
            toast.success("Gallery updated successfully");
            await getalluserdata();
        }
        setIsLoading(false);
    };
    
    const saveGallery = async (galleryImages, videos) => {
        try {
            const tableSchema = "";
            const tableName = "doctor_gallery";
            const data = {
                user_id: await getuserdata("id"),   
                images: JSON.stringify(galleryImages),
                videos: JSON.stringify(videos)
            };
            const condition = {
                user_id: await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition); 
            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to save gallery");
            }
            return true;
        } catch (error) {
            console.error("Error saving gallery:", error);  
            return false;
        }
    };

    const handleDefaultLocationSubmit = async (e) => {
        e.preventDefault();

        if (!selectedCountry || !searchAddress) {
            toast.error("Country and address are required");
            return;
        }

        setIsLoading(true);
        const success = await saveDefaultLocation(selectedCountry, searchAddress, mapCenter, fullAddress);
        if (success) {
            toast.success("Default location updated successfully"); 
            await getalluserdata();
        }
        setIsLoading(false);
    };
    
    const saveDefaultLocation = async (selectedCountry, searchAddress, mapCenter, fullAddress) => {
        try {
            const tableSchema = "";
            const tableName = "doctor_default_location";
            const data = {
                user_id: await getuserdata("id"),
                country: selectedCountry,
                address: searchAddress,
                lat: mapCenter.lat,
                lng: mapCenter.lng,
                full_address: fullAddress
            };
            const condition = {
                user_id: await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to save default location");
            }
            return true;
        } catch (error) {
            console.error("Error saving default location:", error);
            return false;
        }
    };
    
    const handleSocialProfilesSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        console.log("SOCIAL PROFILES UPDATE NOW:", socialProfiles);
        const success = await saveSocialProfiles(socialProfiles);
        if (success) {
            toast.success("Social profiles updated successfully");
            await getalluserdata();
        }
        setIsLoading(false);
    };
    
    const saveSocialProfiles = async (socialProfiles) => {
        console.log("SOCIAL PROFILES UPDATE :", JSON.stringify(socialProfiles));
        try {
            const tableSchema = "";
            const tableName = "doctor_social_profiles";
            const data = {
                user_id: await getuserdata("id"),
                social_profiles: JSON.stringify(socialProfiles)
            };  
            const condition = {
                user_id: await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to save social profiles");
            }
            return true;
        } catch (error) {
            console.error("Error saving social profiles:", error);
            return false;
        }
    };  
    
    
    
    

    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {isLoading ? (
                    <Preloader />
                ) : (
                    <>
                        {userdata.activation_key == null && (
                            <EmailVerify />
                        )}

                        <section className="dc-haslayout dc-dbsectionspace">
                            <div className="row">
                                <div className={`col-xs-12 col-sm-12 col-md-12  ${tabsest == "Gallery" ? "col-lg-12 col-xl-12" : "col-lg-8 col-xl-9"}`}>
                                    <form className="dc-user-profile" method="post">
                                        <div className="dc-dashboardbox dc-dashboardtabsholder">
                                            <DashBordmenu title="Profile Settings" status={showMenu} onClick={() => { setShowMenu(!showMenu) }} />
                                            <div className="dc-dashboardboxtitle" style={{ display: window.innerWidth < 576 ? 'none' : 'block' }}>
                                                <h2>{tabsest}</h2>
                                            </div>
                                           
                                            <div className="dc-dashboardtabs" style={{ display: window.innerWidth < 576 ? showMenu ? 'block' : 'none' : 'block' }}>
                                                <ul className="dc-tabstitle nav navbar-nav">
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Personal Details" ? 'active' : ''} `} 
                                                           href="#" 
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               handleTabClick("Personal Details");
                                                           }}>
                                                            Personal Details
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Experience & Education" ? 'active' : ''} `} 
                                                           href="#" 
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               handleTabClick("Experience & Education");
                                                           }}>
                                                            Experience &amp; Education
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Awards & Downloads" ? 'active' : ''} `} 
                                                           href="#" 
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               handleTabClick("Awards & Downloads");
                                                           }}>
                                                            Awards &amp; Downloads
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Registrations" ? 'active' : ''} `} 
                                                           href="#" 
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               handleTabClick("Registrations");
                                                           }}>
                                                            Registrations
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Gallery" ? 'active' : ''} `} 
                                                           href="#" 
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               handleTabClick("Gallery");
                                                           }}>
                                                            Gallery
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Default location" ? 'active' : ''} `} 
                                                           href="#" 
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               handleTabClick("Default location");
                                                           }}>
                                                            Default location
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Social profiles" ? 'active' : ''} `} 
                                                           href="#" 
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               handleTabClick("Social profiles");
                                                           }}>
                                                            Social profiles
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            {tabsest == "Personal Details" && (
                                                <ProfileDetails PersonalDetailsformdata={PersonalDetailsformdata} setPersonalDetailsFormdata={setPersonalDetailsFormdata} />
                                            )}

                                            {tabsest == "Experience & Education" && (
                                                <ExperienceEducation educations={educations} setEducations={setEducations} experiences={experiences} setExperiences={setExperiences} />
                                            )}

                                            {tabsest == "Awards & Downloads" && (
                                                <AwardsDownloads awards={awards} setAwards={setAwards} downloads={downloads} setDownloads={setDownloads} />
                                            )}
                                            {tabsest == "Registrations" && (
                                                <Registrations localRegistrations={localRegistrations} setLocalRegistrations={setLocalRegistrations} isUploading={isUploading} setIsUploading={setIsUploading} isSaving={isSaving} setIsSaving={setIsSaving} hasChanges={hasChanges} setHasChanges={setHasChanges} />
                                            )}
                                            {tabsest == "Gallery" && (
                                                <Gallery galleryImages={galleryImages} setGalleryImages={setGalleryImages} videos={videos} setVideos={setVideos} newVideoUrl={newVideoUrl} setNewVideoUrl={setNewVideoUrl} isUploading={isUploading} setIsUploading={setIsUploading} galleryid={galleryid}/>
                                            )}
                                            {tabsest == "Default location" && (
                                                <Defaultlocation selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} searchAddress={searchAddress} setSearchAddress={setSearchAddress} mapCenter={mapCenter} setMapCenter={setMapCenter} userdata={userdata} fullAddress={fullAddress} setFullAddress={setFullAddress} />
                                            )}
                                            {tabsest == "Social profiles" && (
                                                <SocialProfiles socialProfiles={socialProfiles} setSocialProfiles={setSocialProfiles} socialloading={socialloading} setSocialLoading={setSocialLoading} />
                                            )}
                                        </div>
                                        <div className="dc-updatall">
                                            <i className="ti-announcement"></i>
                                            <span>Update all the latest changes made by you, by just clicking on Save &amp; Update button.</span>
                                            <a 
                                                className="dc-btn dc-update-profile-doctorss" 
                                                data-id="4174" 
                                                data-post="18128" 
                                                href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (tabsest === "Personal Details") {
                                                        handlesubmit(e);
                                                    } else if (tabsest === "Experience & Education") {
                                                        handleExperienceEducationSubmit(e);
                                                    } else if (tabsest === "Awards & Downloads") {
                                                        handleAwardsDownloadsSubmit(e);
                                                    } else if (tabsest === "Registrations") {
                                                        handleRegistrationsSubmit(e);
                                                    } else if (tabsest === "Gallery") {
                                                        handleGallerySubmit(e);
                                                    } else if (tabsest === "Default location") {
                                                        handleDefaultLocationSubmit(e);
                                                    } else if (tabsest === "Social profiles") {
                                                        handleSocialProfilesSubmit(e);
                                                    }

                                                }}
                                            >
                                                Save &amp; Update
                                            </a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </>
                )}
            </div>
        </>
    );
};

export default ProfileSettings;
